export default __webpack_public_path__ + "static/media/close_white.604f17ae.svg";